import { FormData, CreateProviderPayload, ProviderForPayload } from "../types";
import { ProviderState } from "../../../../../enums";
import {
  getAvailableMethods,
  getDefaultMethods,
  hasBrandsInSchema,
} from "./providerHelpers";
import { getSchemaConstPayloadValues } from "./schemaConstFields";

const ALLOWED_PAYMENT_METHODS = ["PixParcelado", "Credit"];

function filterAllowedMethods(methods: string[]): string[] {
  return methods.filter((m) => ALLOWED_PAYMENT_METHODS.includes(m));
}

export function buildProviderPayload(
  selectedProvider: ProviderForPayload,
  formData: FormData,
): CreateProviderPayload {
  const { schema } = selectedProvider;
  const schemaConstValues = getSchemaConstPayloadValues(schema);

  const priority = formData.priority ?? schemaConstValues.priority;
  if (priority == null) {
    throw new Error("Priority is required");
  }

  const rawMethods =
    getAvailableMethods(schema).length > 0
      ? getAvailableMethods(schema)
      : getDefaultMethods(schema);
  const methods = filterAllowedMethods(rawMethods);
  const finalMethods = methods.length > 0 ? methods : ["Credit"];

  const hasBrands = hasBrandsInSchema(schema);
  const brands = hasBrands ? formData.brands || [] : [];

  return {
    name: selectedProvider.name,
    code: selectedProvider.code || "",
    priority,
    methods: finalMethods,
    credentials: {
      type: selectedProvider?.credentials?.type,
      ...(formData.credentials || {}),
      ...schemaConstValues.credentials,
    },
    acquirer: {
      merchantId: formData.merchantId || "",
      brands,
    },
    state: formData.isActive ? ProviderState.Enabled : ProviderState.Disabled,
    type: selectedProvider?.type || "Gateway",
  };
}
